import React, { useState } from "react";
import client, { apiError } from "@/api/client";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AlertTriangle, Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";

const WIPES = [
  "Semua Penjualan, Retur & Shift/Kas kasir",
  "Semua Pembelian",
  "Semua Purchase Order",
  "Semua Transfer Cabang",
  "Riwayat pergerakan stok (ledger) & opname",
  "Semua Pesanan Makanan Siap Saji",
  "Stok semua produk menjadi 0 di semua cabang (termasuk Gudang Utama)",
];

export default function ResetData() {
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const doReset = async () => {
    if (confirm !== "RESET") return;
    setLoading(true);
    try {
      const { data } = await client.post("/admin/reset-transactions", { confirm });
      toast.success("Reset berhasil. Semua data transaksi dihapus & stok di-nol-kan.");
      setConfirm("");
      console.info("reset summary", data.deleted);
    } catch (e) {
      toast.error(apiError(e));
    } finally { setLoading(false); }
  };

  return (
    <div className="p-6 max-w-3xl space-y-6 animate-in-up" data-testid="reset-page">
      <div>
        <h1 className="font-heading text-3xl font-bold tracking-tight flex items-center gap-2 text-rose-600">
          <AlertTriangle className="h-7 w-7" /> Reset Data Transaksi
        </h1>
        <p className="text-sm text-muted-foreground">Menghapus seluruh data transaksi secara permanen untuk memulai dari awal. Data master (produk, cabang, pengguna, supplier, pelanggan) tetap aman.</p>
      </div>

      <Card className="border-rose-200 bg-rose-50/50 p-6 space-y-4">
        <div className="text-sm font-semibold text-rose-700">Tindakan ini akan menghapus:</div>
        <ul className="space-y-1.5 text-sm text-slate-700">
          {WIPES.map((w) => (
            <li key={w} className="flex items-start gap-2"><Trash2 className="mt-0.5 h-4 w-4 shrink-0 text-rose-500" /> {w}</li>
          ))}
        </ul>
        <div className="rounded-md border border-rose-300 bg-white p-4 space-y-3">
          <div className="text-sm font-medium text-rose-700">⚠️ Aksi ini tidak dapat dibatalkan. Ketik <span className="font-mono font-bold">RESET</span> untuk melanjutkan.</div>
          <Input
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            placeholder="Ketik RESET"
            className="max-w-xs border-rose-300"
            data-testid="reset-confirm-input"
          />
          <Button
            variant="destructive"
            disabled={confirm !== "RESET" || loading}
            onClick={doReset}
            data-testid="reset-submit"
          >
            {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Trash2 className="mr-2 h-4 w-4" />}
            {loading ? "Mereset..." : "Reset Sekarang"}
          </Button>
        </div>
      </Card>
    </div>
  );
}
